import { motion } from "framer-motion";
import {
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
  Music2,
  Youtube,
} from "lucide-react";
import { IMAGES, LEGAL_LINKS, SOCIAL_LINKS } from "../../data/content";
import { reveal } from "../../lib/motion";

const NAV = [
  { label: "Miss Aura", href: "#seu-lugar" },
  { label: "Embaixadoras", href: "#seu-lugar" },
  { label: "Profissionais", href: "#seu-lugar" },
  { label: "Clientes", href: "#seu-lugar" },
];

const SOCIAL_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  tiktok: Music2,
  linkedin: Linkedin,
  whatsapp: MessageCircle,
};

export const Footer = ({ onJoin }) => {
  const activeSocials = SOCIAL_LINKS.filter((s) => s.url);

  return (
    <footer
      data-testid="footer-section"
      className="grain-overlay bg-cream pt-16 md:pt-24 lg:pt-32"
    >
      <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-6 lg:px-8">
        <motion.img
          {...reveal()}
          src={IMAGES.logo}
          alt="Logo oficial Ministério AURA"
          data-testid="footer-logo"
          className="mx-auto h-36 w-36 rounded-full object-cover shadow-[0_20px_60px_rgba(197,160,89,0.25)] sm:h-44 sm:w-44"
        />
        <motion.p
          {...reveal(0.1)}
          className="mt-10 font-serif text-3xl italic text-ink sm:text-4xl"
        >
          "Você não chegou até aqui por acaso..."
        </motion.p>
        <motion.p
          {...reveal(0.2)}
          className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-mutedink sm:text-lg"
        >
          Filha de um Rei. Protagonista da sua história. Mulher de propósito.
          Mulher de serviço. Mulher de legado.
        </motion.p>
        <motion.p
          {...reveal(0.3)}
          className="mt-6 font-serif text-2xl text-teal sm:text-3xl"
        >
          Bem-vinda ao AURA.
        </motion.p>
        <motion.div {...reveal(0.4)} className="mt-10">
          <button
            data-testid="footer-join-cta"
            onClick={onJoin}
            className="rounded-full bg-teal px-10 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-teal-hover sm:text-sm"
          >
            Fazer parte do AURA
          </button>
        </motion.div>
      </div>

      <div className="relative z-10 mt-16 border-t border-gold-border md:mt-24">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-5 py-8 sm:px-6 md:flex-row md:justify-between lg:px-8">
          <div className="flex items-center gap-3">
            <img
              src={IMAGES.logo}
              alt="Logo Ministério AURA"
              className="h-9 w-9 rounded-full object-cover"
            />
            <span className="text-xs text-mutedink">
              © 2026 Ministério AURA. Todos os direitos reservados.
            </span>
          </div>
          <nav
            data-testid="footer-links"
            className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2"
          >
            {NAV.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-xs uppercase tracking-[0.15em] text-mutedink transition-colors duration-300 hover:text-teal"
              >
                {item.label}
              </a>
            ))}
            {LEGAL_LINKS.map((item) =>
              item.url ? (
                <a
                  key={item.id}
                  data-testid={`footer-legal-${item.id}`}
                  href={item.url}
                  className="text-xs uppercase tracking-[0.15em] text-mutedink transition-colors duration-300 hover:text-teal"
                >
                  {item.label}
                </a>
              ) : (
                <span
                  key={item.id}
                  data-testid={`footer-legal-${item.id}`}
                  aria-disabled="true"
                  className="cursor-default text-xs uppercase tracking-[0.15em] text-mutedink/50"
                >
                  {item.label}
                </span>
              )
            )}
          </nav>
          {activeSocials.length > 0 && (
            <div data-testid="footer-social" className="flex items-center gap-3">
              {activeSocials.map((s) => {
                const Icon = SOCIAL_ICONS[s.id];
                return (
                  <a
                    key={s.id}
                    data-testid={`footer-social-${s.id}`}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${s.label} AURA`}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-gold-border text-mutedink transition-colors duration-300 hover:bg-teal hover:text-white"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};
